import React from 'react'
import { Box, Menu, NavLink, Text } from '@mantine/core'
import { ChevronDownIcon } from '@radix-ui/react-icons'

import { StepNavLink } from '@/components/Event/NewScript/components/common/Stepper/StepNavLink'
import { useScriptState } from '@/components/Event/NewScript/hooks/state/useScriptState'
import { useStepsNavigation } from '@/components/Event/NewScript/hooks/useStepsNavigation'
import { Event } from '@/types'

export type StepsNavigationProps = {
  collapsed?: boolean
  event: Event
}

export const StepsNavigation = ({
  event,
  collapsed = false,
}: StepsNavigationProps) => {
  const {
    setCurrentStep,
    isIncomplete,
    getNavColor,
    getStatusLabel,
    scriptSteps,
  } = useStepsNavigation(event)

  const {
    state: { current_step },
  } = useScriptState()

  const StepNavItem: React.FC<{ label: string; step: string }> = ({
    label,
    step,
  }) => {
    return (
      <NavLink
        disabled={isIncomplete(step)}
        active={current_step === step}
        onClick={() => setCurrentStep(step)}
        label={
          <StepNavLink
            label={label}
            description={getStatusLabel(step)}
            color={getNavColor(step)}
          />
        }
      />
    )
  }

  const StepMenuItem: React.FC<{ label: string; step: string }> = ({
    label,
    step,
  }) => {
    return (
      <Menu.Item
        disabled={isIncomplete(step)}
        color={current_step === step ? 'blue' : undefined}
        data-hovered={true}
        onClick={() => setCurrentStep(step)}
      >
        <StepNavLink
          label={label}
          description={getStatusLabel(step)}
          color={getNavColor(step)}
        />
      </Menu.Item>
    )
  }

  if (collapsed) {
    return (
      <Menu shadow="md" width={320} position="bottom-start">
        <Menu.Target>
          <NavLink
            w="auto"
            pl={0}
            label={
              <Text c="black" fz="lg" fw={700}>
                Proceeding
              </Text>
            }
            color="black"
            rightSection={<ChevronDownIcon />}
          />
        </Menu.Target>
        <Menu.Dropdown>
          {scriptSteps.map(({ key, label, offset }) => (
            <Box key={key} ml={offset ? 'sm' : undefined}>
              <StepMenuItem key={key} label={label} step={key} />
            </Box>
          ))}
        </Menu.Dropdown>
      </Menu>
    )
  }

  return (
    <Box w={280}>
      <Text fw={700} fz="lg" ml="sm" mb="lg">
        Proceeding
      </Text>
      {scriptSteps.map(({ key, label, offset }) => (
        <Box key={key} ml={offset ? 'sm' : undefined}>
          <StepNavItem key={key} label={label} step={key} />
        </Box>
      ))}
    </Box>
  )
}
